import { MapElementFactory } from "vue2-google-maps";

export default MapElementFactory({
    name: "directionsRenderer",

    ctr() {
        return window.google.maps.DirectionsRenderer;
    },

    events: [],

    mappedProps: {},

    props: {
        origin: { type: [Object, Array] },
        destination: { type: [Object, Array] },
        travelMode: { type: String },
        waypoints: { type: [Object, Array] },
        route: { type: [Object]}
    },

    afterCreate(directionsRenderer) {
        let directionsService = new window.google.maps.DirectionsService();

        this.$watch(
            () => [this.origin, this.destination, this.travelMode, this.waypoints, this.route],
            () => {
                let { origin, destination, travelMode, waypoints, route } = this;
                if (!origin || !destination || !travelMode) return;
                if (route) {
                    directionsRenderer.setOptions({"preserveViewport": true});
                    directionsRenderer.setDirections(route);
                } else {
                    directionsService.route(
                        {
                            origin,
                            destination,
                            travelMode,
                            waypoints,
                            optimizeWaypoints: true
                        },
                        (response, status) => {
                            if (status !== "OK") return;
                            directionsRenderer.setOptions({"preserveViewport": true});
                            directionsRenderer.setDirections(response);
                            this.$emit('route', response);
                        }
                    );
                }
            }
        );
    },
});
